/**
 * Public surface of ``src/lib/observability``.
 *
 * Consumers import from ``@/lib/observability``, not from the individual
 * files. Keeps refactors of the internal layout invisible to the rest of
 * the app.
 */

export {
  ObservabilityContext,
  useObservability,
  type ObservabilityContextValue,
} from "@/lib/observability/context";
export { ObservabilityProvider } from "@/lib/observability/provider";
export { ObservabilityBridge } from "@/lib/observability/bridge";
export { ObservabilityErrorBoundary } from "@/lib/observability/error-boundary";
export {
  redactEvent,
  type RedactableEvent,
} from "@/lib/observability/redactor";
export { resetIdentity } from "@/lib/observability/reset";
